import { render } from "./OrdersApproved.vue?vue&type=template&id=36d7f10d&scoped=true"
import script from "./OrdersApproved.vue?vue&type=script&lang=js"
export * from "./OrdersApproved.vue?vue&type=script&lang=js"

import "./OrdersApproved.vue?vue&type=style&index=0&id=36d7f10d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d7f10d"]])

export default __exports__